import React, { useState,useEffect } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import { Button} from 'react-bootstrap';
//import { TbSquareRoundedLetterA, TbCircleLetterA } from 'react-icons/tb';
import { BsPersonFillX, BsPersonFillCheck } from 'react-icons/bs';




const Segna_presenza_assenza = (props) => {
//    const [somma, calcola_somma] = useState('');
    const [checked, setChecked] = useState(false);
    const [radioValue, setRadioValue] = useState();

    const radios = [
        { name: 'Radio123', value: '2' },
        { name: 'Radio', value: '3' },
    ];

    useEffect(() => {

    }, [props.variabile_presenza]);

    function handleSelect (e) {
        console.log('ciao ' + e)
    }    

    function Scelta_programma2 (event, parametro) {
//        event.preventDefault()
//        console.log("sssssssssss  " + parametro + ' - ' + event.target.value)
        
        
        if (parametro == 0 && props.parametro_passato == 'alunno1') {
            props.SET_input(prevInput => {
                return {
                    ...prevInput,
                    [props.parametro_passato]: parametro,
                    ['orario_mattina_in']: -1,
                    ['orario_mattina_out']: -1
                }
            })
        }
        if (parametro == 0 && props.parametro_passato == 'alunno2') {
            props.SET_input(prevInput => {
                return {
                    ...prevInput,
                    [props.parametro_passato]: parametro,
                    ['orario_pomerig_in']: -1,
                    ['orario_pomerig_out']: -1
                }
            })
        }
        if (parametro != 0) {
            props.SET_input(prevInput => {
                return {
                    ...prevInput,
                    [props.parametro_passato]: parametro
                }
            })
        }
    }


    function Bottone_con_tre_opzioni () {
        if (props.variabile_presenza == 1) {
            return <>
                <Button onClick={(event) => Scelta_programma2(event, 0)} 
                variant="outline-primary" disabled={false} value={1}> {<BsPersonFillCheck color='green'  size='1.6rem'/>} </Button>
            </>
        }
        if (props.variabile_presenza == 0) {
            return <>
                <Button onClick={(event) => Scelta_programma2(event, -1)} 
                variant="outline-primary" disabled={false} value={1}> {<BsPersonFillCheck color='red'  size='1.6rem'/>} </Button>
            </>
        }
        if (props.variabile_presenza != 0 && props.variabile_presenza != 1) {
            return <>
                <Button onClick={(event) => Scelta_programma2(event, 1)} 
                variant="outline-primary" disabled={false} value={1}> {<BsPersonFillCheck color='gray'  size='1.6rem'/>} </Button>
            </>
        }
    }


    
    function Controlla_se_sabato_pomeriggio () {
         
        let data_passata = new Date(props.data_sulla_riga)
        if (!(data_passata.getDay() === 6 && props.evento == 'Pomeriggio')) {
            return <>
             
            {props.giornata_da_modificare != 1 && props.variabile_presenza_fissa == 1 && <BsPersonFillCheck color='green' size='1.6rem'/>} 
            {props.giornata_da_modificare != 1 && props.variabile_presenza_fissa == 0 && <BsPersonFillX color='red' size='1.6rem'/>}
            {props.giornata_da_modificare && 
            <div className="d-flex flex-row-reverse">
                {/* 
                    <ButtonGroup  onClick={Scelta_programma2}>
                        <ToggleButton
                            key={1}
                            id={'radio-1' + props.evento}
                            type="radio"
                            variant={1 == 1 ? 'outline-success' : 'outline-danger'}
                            name={"radio1" + props.evento}
                            value={1}
                            checked={props.variabile_presenza == 1} >
                            {'presente'}
                        </ToggleButton>
                        <ToggleButton
                            key={2}
                            id={'radio-2'+ props.evento}
                            type="radio"
                            variant={1 == 0 ? 'outline-success' : 'outline-danger'}
                            name={"radio2" + props.evento}
                            value={0}
                            checked={props.variabile_presenza == 0} >
                            {'assente'}
                        </ToggleButton>
                    </ButtonGroup>
                */}
                {Bottone_con_tre_opzioni()}

            </div>
              
            }
            </>
        }
    }



    return (
    <div className="d-flex flex-row justify-content-between">

                {/* idroslab  come faccio a cambiare l-icona in base al button*/}

        {Controlla_se_sabato_pomeriggio()}
       
    </div>
    )
}
export default Segna_presenza_assenza;